<template>
  <div>
    <LoginLayout
      :loginHeading="'Forgot Password?'"
      :primaryButtonText="'Email Link'"
      :sendingMailErrorMessage="sendingMailError.message"
      :showErrorMessage="sendingMailError.show"
      :sendingMail="sendingMail"
      :emailSent="emailSent"
      @submit="requestPassword"
    >
      <form class="mt-3" @submit.prevent="requestPassword()"  @keyup.enter="requestPassword()">
        <div class="row row-spacing">
          <div class="col-md-12">
            <label class="">Email</label>
            <div class="input-group mb-3">
              <input type="text" class="form-control" placeholder="Email" autocomplete="off" v-model="loginCredentials.userName" required>
              <div class="input-group-append">
                <span class="input-group-text bg-white"><i class="fa fa-envelope-o"></i></span>
              </div>
            </div>
          </div>
        </div>
      </form>
    </LoginLayout>
  </div>
</template>

<script>
import LoginLayout from '@/layouts/LoginLayout';
  export default {
    components: {
      LoginLayout
    },
    data() {
      return {
        loginCredentials: {
          userName: "",
        },
        sendingMailError: {
          message: "",
          show: false
        },
        sendingMail: false,
        emailSent: false,
      }
    },
    mounted() {
      document.title = 'Forgot password | Service Panel';
    },
    methods: {
      requestPassword: function() {
        this.sendingMailError.show = false;
        this.sendingMail = true;
        this.emailSent = true;
        const hostUrl = this.$config.aimsAPI;
        const userCredentials = this.loginCredentials;

        this.$http.post(`${hostUrl}passwordrecovery/forgotpassword`, userCredentials).then(
          (response) => {
            setTimeout(this.showSuccess(response.data.message), 1500);
          },
          (error) => {
            if (error.status === 0) {
              error.data = {
                message: "Could not contact server"
              };
            }

            this.sendingMailError.message = error.data.message;
            this.sendingMailError.show = true;
          }).finally(() => {
            this.sendingMail = false;
          });
      }
    },  
  }
</script>